import { InjectionToken } from '@angular/core';

export const APP_VERSION_TOKEN = new InjectionToken <string> ('app.version');

